<template>
  <div
    :class="['ListRefinement--dropdown-positioning-' + dropdownPositioning, {
      'ListRefinement--selected': props.selected,
    }]"
  >
    <FilterHeading
      :title="props.title"
      :group-value="props.groupValue"
      :selected="props.selected"
      class="ListRefinement__header"
      @click="toggleShowFilters"
    />
    <AisRefinementList
      class="ListRefinement__list-container"
      :attribute="props.attribute.attributeForFacet"
    >
      <template #default="{ items, refine, createURL }">
        <ul class="ListRefinement__list">
          <li
            v-if="items.length === 0"
            class="ListRefinement__list-item--no-results"
          >
            No options to show here.
          </li>
          <li
            v-for="item in items"
            v-else
            :key="item.value"
            class="ListRefinement__item"
          >
            <a
              class="ListRefinement__item-content"
              :href="createURL(item)"
              @click.prevent="refine(item.value), trackClick(item)"
            >
              <FilterItem
                :item="item"
              />
            </a>
          </li>
        </ul>
      </template>
    </AisRefinementList>
  </div>
</template>

<script setup>
const { $track } = useNuxtApp()

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: false,
    default: '',
  },
  selected: {
    type: Boolean,
    required: false,
    default: false,
  },
  groupValue: {
    type: String,
    required: false,
    default: '',
  },
  dropdownPositioning: {
    type: String,
    required: false,
    default: 'dropdown',
    validator(value) {
      return ['dropdown', 'sidebar'].includes(value)
    }
  }
})

const emits = defineEmits(['toggleActiveFilterGroup'])

function toggleShowFilters() {
  emits('toggleActiveFilterGroup', props.attribute.filterGroupValue)
}

async function trackClick(item) {
  await $track.global.linkClicked({
    linkText: item.label,
    interactionElement: item.value,
    interactionSection: props.groupValue,
    interactionCategory: !item.isRefined
      ? 'Checked filter option'
      : 'Unchecked filter option',
  })
}
</script>

<style lang="postcss">
.ListRefinement--no-refinement {
  @apply hidden;
}


.ListRefinement--dropdown-positioning-dropdown {
  .ListRefinement__list-container {
    @screen lg {
      @apply absolute left-0 w-full pt-6 pb-8 bg-white z-11 border-b border-grey-400;

      top: calc(100% + 1px);
    }
  }
}

.ListRefinement--dropdown-positioning-sidebar {
  .ListRefinement__list {
    @apply p-0;
  }
}

.ListRefinement--selected {
  .ListRefinement__list-container {
    @apply flex;
  }
}

.ListRefinement__list-container {
    @apply hidden;
}

.ListRefinement__header {
  @apply lg:mr-10;
}

.ListRefinement__list {
  @screen lgMax {
    @apply pb-4;
  }

  @apply flex flex-wrap gap-x-1 gap-y-1 global-wrapper text-off-black;
}

.ListRefinement__item {
  @apply p-2 w-full;

  @screen lg {
    @apply min-w-min;

    flex-basis: content;
  }
}

.ListRefinement__list-item--no-results {
  @apply py-6;
}

.ListRefinement__item-content {
  @apply flex items-center gap-x-2 text-sm text-off-black;
}
</style>
